/* CS cart page: previous / next arrows for the "Add to your order" carousel, built as soon as the carousel
   initialises (no timers), then the block fades in so the column does not jump while it loads. */
;(() => {
	'use strict'
	const tapDot = (dot) => {
		const box = dot.getBoundingClientRect()
		const base = { bubbles: true, cancelable: true, composed: true, view: window, clientX: box.x + box.width / 2, clientY: box.y + box.height / 2, pointerId: 1, isPrimary: true, button: 0 }
		if (window.PointerEvent) {
			dot.dispatchEvent(new PointerEvent('pointerdown', { ...base, buttons: 1 }))
			dot.dispatchEvent(new PointerEvent('pointerup', { ...base, buttons: 0 }))
		} else {
			dot.dispatchEvent(new MouseEvent('mousedown', { ...base, buttons: 1 }))
			dot.dispatchEvent(new MouseEvent('mouseup', { ...base, buttons: 0 }))
		}
		dot.dispatchEvent(new MouseEvent('click', { ...base, buttons: 0 }))
	}
	const ready = (pair) => pair.classList.add('cs-ready')
	const setup = (pair) => {
		const carousel = pair.querySelector('.flickity-enabled')
		const dots = pair.querySelector('.flickity-page-dots')
		if (!carousel) return false
		if (!dots || dots.querySelectorAll('.dot').length < 2 || pair.querySelector('.cs-upnav')) { ready(pair); return true }
		const nav = document.createElement('div')
		nav.className = 'cs-upnav'
		const mk = (dir, label) => { const b = document.createElement('button'); b.type = 'button'; b.className = 'cs-upnav__btn'; b.dataset.dir = dir; b.setAttribute('aria-label', label); return b }
		dots.before(nav)
		nav.append(mk(-1, 'Previous suggestion'), dots, mk(1, 'Next suggestion'))
		nav.addEventListener('click', (e) => {
			const b = e.target.closest('[data-dir]')
			if (!b) return
			const all = [...dots.querySelectorAll('.dot')]
			const cur = Math.max(0, all.findIndex((d) => d.classList.contains('is-selected')))
			tapDot(all[(cur + Number(b.dataset.dir) + all.length) % all.length])
		})
		ready(pair)
		return true
	}
	const watch = (pair) => {
		if (pair.dataset.csWatch) return
		pair.dataset.csWatch = '1'
		if (setup(pair)) return
		const mo = new MutationObserver(() => { if (setup(pair)) mo.disconnect() })
		mo.observe(pair, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] })
		setTimeout(() => { mo.disconnect(); ready(pair) }, 3000) // never leave the block hidden
	}
	const init = () => document.querySelectorAll('[id^="Cart--"] .cart__pair').forEach(watch)
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init)
	else init()
	;['theme:cart:added', 'theme:cart:loaded', 'theme:cart:refresh'].forEach((n) => document.addEventListener(n, () => requestAnimationFrame(() => { document.querySelectorAll('[id^="Cart--"] .cart__pair').forEach((p) => { delete p.dataset.csWatch; watch(p) }) })))
})()
